
@if (showPage()) {
  <div class="ot-panel">
    <div class="ot-panel__header">
      @if (isSupportHotfix && isMasterSystemOnline && isQuickAnalysisRequired) {
        <div class="ot-message ot-message--is-error">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
                An analysis of the primary system must be completed before continuing.&nbsp;<a (click)="analyzeMasterSystemClicked()">Analyze primary system</a>
                </p>
          </div>
        </div>
      }
      @if (isSupportHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && !isMasterSystemSelected) {
        <div class="ot-message ot-message--is-error">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
                    A primary system must be selected. Please review the error below.
                </p>
          </div>
        </div>
      }
      @if (!isMasterSystemOnline) {
        <div class="ot-message ot-message--is-error">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
                    The agent on the primary system is offline.
                </p>
          </div>
        </div>
      }
    </div>
    <div class="resync-no-errors" [ngClass]="{'resync-errors': isError()}">
      <ng-scrollbar>
        <div class="ot-row">
          <div class="ot-row__column">
            <div role="group" class="ot-btn-group ot-mb-0">
              <button role="button" i18n-title title="Resynchronize" class="ot-btn ot-btn--is-primary" [disabled]="state == ResyncState.IN_PROGRESS || selectedInstanceRows.length == 0 || !isMasterSystemOnline || isQuickAnalysisRequired" (click)="resync()">Resynchronize</button>
              <button role="button" i18n-title title="Back" class="ot-btn" [disabled]="state == ResyncState.IN_PROGRESS" (click)="back()" i18n>Back</button>
            </div>
          </div>
        </div>
        <div class="ot-row">
          <p class="ot-pl-1 ot-pr-1" i18n>
                    Resynchronizing an instance updates the information here to reflect the information currently stored in Content Server. Resynchronize an instance if you suspect the information to be out of date.
                </p>
        </div>
        @if (state != ResyncState.INIT) {
          <div class="ot-row">
            @if (isSupportHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && isMasterSystemSelected && state == ResyncState.IN_PROGRESS) {
              <div class="ot-message ot-message--is-progress w-100">
                <div class="ot-message__banner">
                  <p class="ot-message__item" i18n>
                            {getNumResyncInstances(),
                                plural,
                                =1 { Resynchronzing an instance. Please wait...}
                                other { Resynchronzing {{getNumResyncInstances()}} instances. Please wait...}
                                }
                        </p>
              </div>
            </div>
          }
          @if (isSupportHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && isMasterSystemSelected && state == ResyncState.COMPLETE_SUCCESS) {
            <div class="ot-message ot-message--is-success w-100">
              <div class="ot-message__banner">
                <p class="ot-message__item" i18n>
                            {getNumResyncInstances(),
                                plural,
                                =1 { {{getNumSuccessCompletedResyncInstances()}} instance was resynchronzied successfully.}
                                other { {{getNumSuccessCompletedResyncInstances()}} instances were resynchronzied successfully.}
                                }
                        </p>
            </div>
          </div>
        }
        @if (isSupportHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && isMasterSystemSelected && state == ResyncState.COMPLETE_ERROR) {
          <div class="ot-message ot-message--is-error w-100">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                            {{getNumResyncInstances() - getNumSuccessCompletedResyncInstances()}}/{{getNumResyncInstances()}} instance(s) could not be resynchronzed. View&nbsp;<a (click)="viewError()">details</a>
                        </p>
            </div>
          </div>
        }
      </div>
    }
    <app-tabs [identifier]="'product-resync-tabs'" [tabs]="tabs" [color]="TabColor.PRIMARY"></app-tabs>
    <app-datatable [identifier]="'product-resync-instance-table'" (selectAllClickEvent)="selectAllToResync($event)" [isloading]="isLoading"
      (checkboxchangeevent)="selectToResync($event)" [showcheckboxes]="true" [title]="''" [overrideShowError]="true" [cols]="componentTableCols"
    [rows]="componentTableRows" (actionmenuevent)="actionMenuClicked($event)" (rowclickevent)="rowClick($event)" [scroll]="false"></app-datatable>
  </ng-scrollbar>
</div>
</div>
} @else {
  <div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter"></div>
    </div>
    @if (isLoading && !isManifestUpdating && !isAgentManifestUpdating) {
      <div class="ot-progress__text" i18n>Loading...</div>
    }
    @if (isManifestUpdating) {
      <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
    }
    @if (isAgentManifestUpdating) {
      <div class="ot-progress__text" i18n>Please wait while the Agent manifest is updated...</div>
    }
  </div>
}
